module.exports = __webpack_public_path__ + "img/garde-suisse.55216994.jpg";